import React, { useEffect } from 'react';
import Select from 'react-select';

import useGlobal from '../../../../store';
import Loading from '../../../../facturotopia/loading/Loading';

const mapState = (state) => {
  return {
    data: state.app.usuarios.sucursales.data,
  };
};

const mapActions = (actions) => {
  const { usuarios } = actions.app;

  return {
    getSucursales: usuarios.sucursales.sucursal,
  };
};

const SucursalSelection = (props) => {
  const [state, actions] = useGlobal(mapState, mapActions);

  useEffect(() => {
    actions.getSucursales();
  }, []); // eslint-disable-line

  const options = (data) => {
    const options = data.map((item) => {
      return {
        label: item.id,
        value: item.id,
      };
    });

    return [
      {
        label: 'Selecciona una sucursal',
        value: '',
      },
    ].concat(options);
  };

  const handleChange = (selectedOptions) => {
    props.onChange({ sucursales: selectedOptions });
  };

  if (state.busy) {
    return <Loading />;
  }

  return (
    <Select
      closeMenuOnSelect={false}
      closeMenuOnScroll={true}
      value={props.data}
      isMulti={true}
      onChange={handleChange}
      options={options(state.data)}
    />
  );
};

export default SucursalSelection;
